import React from 'react';
import { useEffect, useState } from 'react';
import { getPlant } from '../../services/plantService';

function OrderCard({ order, onViewDetails }) {
    const [plant, setPlant] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPlant(order.plant_id)
            .then((response) => {
                setPlant(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }
        , [order]);

    if (loading) {
        return (
            <div className="w-full p-4 bg-gray-700 rounded-lg mb-4 shadow-md">
                <h3 className="text-lg font-bold text-white">Order #{order.order_id}</h3>
                <p className="text-sm text-gray-400">Loading...</p>
            </div>
        );
    }

    return (
        <div className="w-full p-4 bg-gray-700 rounded-lg mb-4 shadow-md"> {/* Dark background and shadow */}
            <h3 className="text-lg font-bold text-white">Order #{order.order_id} : {plant.name}</h3>
            <p className="text-sm text-gray-400">Quantity: {order.quantity}</p>
            <p className="text-sm text-gray-400">Total Price: {order.total_price}</p>
            <button
                className="mt-2 px-4 py-2 font-bold text-white bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 rounded-full"
                onClick={() => onViewDetails(order)}
            >
                View Details
            </button>
        </div>
    );
}

export default OrderCard;
